// eslint-disable-next-line import/prefer-default-export
export const UNKNOWN_ERROR =
  'An unknown error has occurred. Please refresh the page and try again.';
